// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"confirmBlock_wrapper__Pn4tI","image_container":"confirmBlock_image_container__XiBK4"};